import { ThemeOptions } from '@mui/material/styles';

/** Rosa — baseado no tema padrão com paleta rosa */
export const rosaPaletteOptions: ThemeOptions['palette'] = {
  mode: 'light',
  primary: {
    main: '#D81B7A',
    light: '#F06292',
    dark: '#AD1457',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#9C27B0',
    light: '#BA68C8',
    dark: '#7B1FA2',
    contrastText: '#ffffff',
  },
  error: {
    main: '#f44336',
    light: '#ef5350',
    dark: '#c62828',
  },
  warning: {
    main: '#ff9800',
    light: '#ffb74d',
    dark: '#f57c00',
  },
  info: {
    main: '#D81B7A',
    light: '#F06292',
    dark: '#AD1457',
  },
  success: {
    main: '#4caf50',
    light: '#81c784',
    dark: '#388e3c',
  },
  background: {
    default: '#fdf2f7',
    paper: '#ffffff',
  },
  text: {
    primary: '#333333',
    secondary: '#666666',
    disabled: '#9e9e9e',
  },
  divider: 'rgba(216, 27, 122, 0.12)',
  action: {
    active: '#666666',
    hover: 'rgba(216, 27, 122, 0.08)',
    selected: 'rgba(216, 27, 122, 0.14)',
    disabled: 'rgba(0, 0, 0, 0.26)',
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
  },
  grey: {
    50: '#fdf2f7',
    100: '#fce4ec',
    200: '#f8bbd0',
    300: '#f48fb1',
    400: '#f06292',
    500: '#ec407a',
    600: '#d81b60',
    700: '#c2185b',
    800: '#ad1457',
    900: '#880e4f',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161',
  },
  gradient: {
    primary: 'linear-gradient(45deg, #AD1457 30%, #D81B7A 55%, #F06292 100%)',
    secondary: 'linear-gradient(45deg, #7B1FA2 30%, #BA68C8 90%)',
  },
};

export const rosaComponentOverrides: ThemeOptions['components'] = {
  MuiCssBaseline: {
    styleOverrides: {
      body: {
        scrollbarColor: '#f8bbd0 transparent',
      },
    },
  },
  MuiDrawer: {
    styleOverrides: {
      paper: {
        backgroundColor: '#ffffff',
        backgroundImage: 'none',
        borderRight: '1px solid #f3d5e3',
      },
    },
  },
  MuiAppBar: {
    styleOverrides: {
      root: {
        backgroundImage: 'none',
        boxShadow: '0 2px 4px rgba(216, 27, 122, 0.12)',
      },
    },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        border: '1px solid rgba(216, 27, 122, 0.1)',
        boxShadow: '0 4px 20px rgba(216, 27, 122, 0.08)',
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        backgroundImage: 'none',
      },
    },
  },
  MuiTableCell: {
    styleOverrides: {
      root: {
        borderColor: 'rgba(216, 27, 122, 0.1)',
      },
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: 'rgba(216, 27, 122, 0.22)',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: 'rgba(216, 27, 122, 0.45)',
        },
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      containedPrimary: {
        boxShadow: '0 4px 14px rgba(216, 27, 122, 0.35)',
      },
    },
  },
  MuiChip: {
    styleOverrides: {
      colorPrimary: {
        backgroundColor: 'rgba(216, 27, 122, 0.12)',
        color: '#AD1457',
      },
    },
  },
};
